import 'react-app-polyfill/stable'
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { BrowserRouter as Router } from 'react-router-dom';

import HomePage from "./Pages/Home/HomePage";
import AwardCategoryListPage from './Pages/AwardCategoryList/AwardCategoryListPage';
import AwardPage from "./Pages/Award/AwardPage";
import FooterLogo from "./Components/FooterLogo";
import EntryPage from "./Pages/Entry/EntryPage";
import HelpIcon from "@mui/icons-material/Help";
import NotFound from "./Pages/NotFound";
import NotesPage from './Pages/Notes/NotesPage';
import PrimeButton from "./Components/PrimeButton";
import { generatePathAwards, pathPatterns } from './Utils/Routes';
import LoadingSpinner from './Components/LoadingSpinner'
import GoogleAnalyticsPage from './Components/GoogleAnalyticsPage';
import MyListPage from './Pages/MyList/MyListPage';
import { useUser } from './Utils/User';
import { Route, Routes } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    root: {
        fontSize: '16px',
        minHeight: '100vh',
        //overflow: "auto",
        width: '100%',
        // position: 'relative',
    },
    helpBtnWrap: {
        position: 'fixed',
        zIndex: 100,
        bottom: theme.spacing(4),
        right: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            display: "none",
        },
    },
    helpBtn: {
        'borderRadius': '30px',
        'padding': '10px 15px',
    },
}));

const HelpIconComponent = <HelpIcon />;

function App() {
    const classes = useStyles();

    const user = useUser();

    const isLoadingApp = !user;

    return (
        <Router>
            <GoogleAnalyticsPage siteId={process.env.REACT_APP_GTAG_SITE_ID}>
                {!isLoadingApp ? (
                    <div className={`app ${classes.root}`}>
                        <Routes>
                            <Route exact path={pathPatterns.awards} element={<HomePage />} />
                            <Route path={pathPatterns.mylist} element={<MyListPage />} />
                            <Route path={pathPatterns.categories} element={<AwardCategoryListPage backUrl={generatePathAwards()} />} />
                            <Route path={pathPatterns.notes} element={<NotesPage backUrl={generatePathAwards()} title="My Notes" />} />
                            <Route path={pathPatterns.entry} element={<EntryPage />} />
                            <Route path={pathPatterns.categoryEntry} element={<EntryPage />} />
                            <Route path={pathPatterns.category} element={<AwardPage key="category" />} />
                            <Route path={pathPatterns.award} element={<AwardPage key="award" />} />
                            <Route element={<NotFound />} />
                        </Routes>

                        <div className={classes.helpBtnWrap}>
                            <PrimeButton
                                className={classes.helpBtn}
                                icon={HelpIconComponent}
                                text="Help"
                                href={process.env.REACT_APP_HELPSITE_URI}
                            />
                        </div>
                        <Box justifyContent="center">
                            <FooterLogo />
                        </Box>
                    </div>
                ) : (
                    <LoadingSpinner />
                )}
            </GoogleAnalyticsPage>
        </Router>
    );
}

export default App;
